'use strict';

// //////////////////////////////////////////////////////////
// This helper is already imported in our common bundle !
// //////////////////////////////////////////////////////////

function toNumericValue(computedStyleValue) {
    if (!computedStyleValue) {
        return 0;
    }
    return parseInt(computedStyleValue.replace(/px|em|%/g, ''), 10);
}

Element.prototype.outerWidth = function ({margin = true, border = true} = {}) {
    const marginLeft = toNumericValue(window.getComputedStyle(this, null).getPropertyValue('margin-left'));
    const marginRight = toNumericValue(window.getComputedStyle(this, null).getPropertyValue('margin-right'));
    const borderWidth = toNumericValue(window.getComputedStyle(this, null).getPropertyValue('border-width')) * 2;
    return this.clientWidth + (margin ? marginLeft + marginRight : 0) + (border ? borderWidth : 0);
};
